import { render, staticRenderFns } from "./SalesPagination.vue?vue&type=template&id=56444b59&scoped=true&"
import script from "./SalesPagination.vue?vue&type=script&lang=js&"
export * from "./SalesPagination.vue?vue&type=script&lang=js&"
import style0 from "./SalesPagination.vue?vue&type=style&index=0&id=56444b59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56444b59",
  null
  
)

export default component.exports